import { pdf } from '@react-pdf/renderer';
import type { POModal, PoModalModifiers, PurchaseOrderDetails, Vendor } from 'api/types';
import { saveAs } from 'file-saver';
import React from 'react';
import PurchaseOrderPdfView from './PurchaseOrderPdfView';
import CustomButton from 'components/NewLayout/Button';

interface Props {
  data: POModal[];
  vendorBillingData: Vendor;
  deliveryAddress: string;
  poModifiers: PoModalModifiers;
  specialInstructions: string;
  poResponse: PurchaseOrderDetails;
  requester: string;
  poDate: string;
  purchaseDate: string;
  buttonLabel?: string;
  onComplete?: () => void;
  paymentTerms: string;
}

const PurchaseOrderPDFDownload: React.FC<Props> = ({
  data,
  vendorBillingData,
  deliveryAddress,
  poModifiers,
  specialInstructions,
  poResponse,
  requester,
  poDate,
  purchaseDate,
  buttonLabel = 'Download Purchase Order',
  onComplete,
  paymentTerms
}) => {
  const generatePDF = async (): Promise<void> => {
    try {
      const blob = await pdf(
        <PurchaseOrderPdfView
          data={data}
          vendorBillingData={vendorBillingData}
          poModifiers={poModifiers}
          poResponse={poResponse}
          specialInstructions={specialInstructions}
          requester={requester}
          poDate={poDate}
          purchaseDate={purchaseDate}
          deliveryAddress={deliveryAddress}
          paymentTerms={paymentTerms}
        />
      ).toBlob();

      saveAs(blob, `${poResponse.purchase_order_number}.pdf`);
      onComplete && onComplete();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  return <CustomButton onClick={() => generatePDF()} variant="outlined" label={buttonLabel} />;
};

export default PurchaseOrderPDFDownload;
